import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Download } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
import { useBreakpointsContext } from "@air/provider-media-query";
import { memo } from "react";
import { ASSET_MODAL_PANEL_TITLE, COLLAPSE_PANE } from "~/constants/testIDs";
import usePrevious from "~/hooks/usePrevious";
export const ContentHeader = /*#__PURE__*/ memo((param)=>{
    let { closePanel, title, adornment, contentHeader } = param;
    const previousTitle = usePrevious(title);
    const { isAboveMediumScreen } = useBreakpointsContext();
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full border-b border-grey-5 pl-6 pr-4",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex h-[60px] items-center justify-start",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        "data-testid": ASSET_MODAL_PANEL_TITLE,
                        className: "mr-auto text-14 font-bold uppercase text-grey-10",
                        children: !title && !!previousTitle ? previousTitle : title
                    }),
                    adornment,
                    isAboveMediumScreen && /*#__PURE__*/ _jsx(Tooltip, {
                        label: "Collapse",
                        children: /*#__PURE__*/ _jsx(IconButton, {
                            appearance: "ghost",
                            color: "grey",
                            "data-testid": COLLAPSE_PANE,
                            onClick: closePanel,
                            label: "Collapse pane",
                            size: "small",
                            children: /*#__PURE__*/ _jsx(Download, {
                                className: "size-4 -rotate-90"
                            })
                        })
                    })
                ]
            }),
            contentHeader
        ]
    });
});
ContentHeader.displayName = "ContentHeader";
